import { P } from "src/typography/typography";

function FormInstructions(props) {
  return (
    <P inactive
      {...props}
    />
  )
}

export default FormInstructions
